<template>
    <!-- Mobile: grid with process (col-span-3) + price per row -->
    <div v-if="!isDesktop" class="grid grid-cols-4 gap-x-5 gap-y-0">
        <template v-for="([processName, cost], index) in config.items" :key="index">
            <div class="font-medium col-span-3">
                <p class="text-md">{{ processName }}</p>
            </div>
            <div class="">
                <p class="text-md font-bold">{{ cost }}</p>
            </div>
        </template>
    </div>
    <!-- Desktop: single row, 3 columns, process above price, divider after each except last -->
    <div v-else class="grid grid-cols-3 gap-y-0">
        <div
            v-for="([processName, cost], index) in config.items"
            :key="index"
            :class="[
                'flex flex-col gap-0',
                index < config.items.length - 1 ? 'border-r border-(--ui-border) pr-5' : '',
                index > 0 ? 'pl-5' : '',
            ]"
        >
            <p class="text-md font-medium">{{ processName }}</p>
            <p class="text-md font-bold">{{ cost }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { AdditionalColorsPricingBlockConfig } from '@/types/blockConfigs'

const { isDesktop } = useIsDesktop()

defineProps<{
    config: AdditionalColorsPricingBlockConfig
}>()
</script>
